<template>
	<div class="demoLeftTop">
		<div class="cell">
			<div class="top">{{target[0].enterredAmount}}</div>
			<div class="bottom">已入市(个)</div>
		</div>
		<div class="cell">
			<div class="top">{{target[1].signedAmount}}</div>
			<div class="bottom">已签约(个)</div>
		</div>
		<div class=" center ">
			<div class="jiangsu">虚拟电厂</div>
			<div class="nengli"><span class="nengliTitle1">总调节能力:</span><span class="num">{{target[4].num}}</span><span class="nengliTitle">kw</span></div>
		</div>
		<div class="cell">
			<div class="top">{{target[2].totalCapacity}}</div>
			<div class="bottom">总容量(MW)</div>
		</div>
		<div class="cell">
			<div class="top">{{target[3].adjustableLoad}}</div>
			<div class="bottom">可调节负荷(MW)</div>
		</div>
		
	</div>
</template>

<script>
	import {
		dataInterface
	} from "@/api/dataInterfaceApi"
	export default {
		components: {
			
		},
		data() {
			return {
				timer1: null,
				target: [
				  {
				    enterredAmount: "",
				  },
				  {
				    
				    signedAmount: "",
				    
				  },
				  {
				    totalCapacity: "",
				  
				  },
				  {
				   adjustableLoad: "",
				   
				  },
				  {
				   num: "10561",
				   
				  },
				],
				}
		},
		destroyed() {
		  clearInterval(this.timer1);
		},
		mounted() {
			this.getData();
			this.timer1 = setInterval(() =>{
			  this.target[4].num = this.generateRandomNumber(10000,30000)
			},15000)
		},
		methods: {
			generateRandomNumber(min, max) {
			  var randomNumber = Math.random() * (max - min) + min;
			  return Math.floor(randomNumber);
			},
			getData() {
				let params = {
					"enCode": 'powerplant-left-hdzrsgk',
					"@city_id": '9237f7b0120e47a7b623ef86a18153b6'
				}
				dataInterface
					.dataFaceApi(params)
					.then((res) => {
						// console.log("南京已入市", res)
						// if (!res) return;
						
						// let regulate_efficiency_fz = [];
						// let regulate_efficiency_xy = [];
						// let xList = [];
						let data = res[0] || {};
						// console.log(data,'data')
						this.target[0].enterredAmount = Math.trunc(data.enterred_amount) || 0;
						this.target[1].signedAmount = Math.trunc(data.signed_amount) || 0;
						this.target[2].totalCapacity = Math.trunc(data.total_capacity )|| 0;
						this.target[3].adjustableLoad = Math.trunc(data.adjustable_load )|| 0;
						
					})
					.catch((err) => {
						console.log(err);
					});
			}
		}
	}
</script>

<style  lang="scss" scoped>
	@import "./comm.scss";

@font-face {
  font-family: "HT";
  src: url("~@/assets/font/HT.ttf");
}
.demoLeftTop{
	display: flex;
	width: 100%;
	height: 190px;
	padding: 0 30px;
	// background-color: yellow;
	.cell{
		flex: 1;
		height: 150px;
		margin: 0 30px;
		margin-top: 40px;
		font-size: 32px;
	}
	.cell:nth-child(1){
		background-image: url("~@/assets/images/exposition/yirushi.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.cell:nth-child(2){
		background-image: url("~@/assets/images/exposition/yiqianyue.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	// .center{
	// 	background-image: url("~@/assets/images/exposition/jiangsuxunidianchang.png");
	// 	background-repeat: no-repeat;
	// 	background-size: 100% 100%;
	// }
	.cell:nth-child(4){
		background-image: url("~@/assets/images/exposition/zongrongliang.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.cell:nth-child(5){
		background-image: url("~@/assets/images/exposition/ketiaojiefuhe.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.center{
		// background-color: yellow;
		width: 598px;
		height: 190px;
		background-image: url("~@/assets/images/exposition/jiangsuxunidianchang.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;
	}
	.top{
		padding-left: 105px; 
		height: 75px;
		line-height: 100px;
		font-size: 64px;
		color: #00FDB1;
		font-family: 'HT';
	}
	.jiangsu{
		font-size: 64px;
		margin-top: 0px;
		text-align: center;
		
	}
		
	.nengli{
		bottom: -65px;
		left: 95px;
		position: absolute;
		
		display: flex;
		line-height: 90px;
		.nengliTitle{
			font-size: 32px;
		}
		.nengliTitle1{
			font-size: 32px;
			font-weight: bold;
		}
		.num{
			display: block;
			margin-left: 10px;
			margin-right:10px ;
			font-family: "HT";
			font-size: 64px;
			color: #00FDB1;
		}
	}
	.bottom{
		padding-left: 100px; 
		height: 75px;
		line-height: 65px;
	}
}	
</style>